import { buildLeadStatusColorMap } from "../constants/leadStatuses";

const STATUS_COLORS = buildLeadStatusColorMap();

export default STATUS_COLORS;
